import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { change } from "redux-form";

// Actions
import { fetchDepartingTrips } from "../../data/trips/actions";

// Selectors
import { getLandingPageFormValues } from "../../data/landingPageForm/selectors";

// Components
import Page from "./components/Page";
import Loader from "../../components/LoadingFlightsPage";

class LocationSuggestionsPage extends Component {
  handleRadioClick = location => () => {
    const { dispatch } = this.props;
    // Replace the redux-store version "origin" and "destination" locations  
    // with the user-clicked versions. So when continue button is clicked, 
    // it sends the correct info to server (instead of the current "manually_entered" version)
    if (location.tripType === "departing") {
      dispatch(change("landingPageForm", "location_from", location));
    } else {
      dispatch(change("landingPageForm", "location_to", location));
    }
  };
  handleContinueButtonClick = () => {
    // console.log("somto continue clicked!");
    const {
      dispatch,
      history,
      to,
      from,
      isRoundTrip, // const isRoundTrip = trip_type === "round_trip"; // Also "!!return_date"
      passengers,
      departDate,
      returnDate,
      preferredCabin
    } = this.props;

    const formValues = {
      isRoundTrip, // true
      returnDate, // "2018-07-10",
      departDate, // "2018-06-15",
      location1: from, // 
      location2: to, // 
      cabinClass: preferredCabin, // economy,premium,business,first (PPN Enum Values)
      children: passengers.childCount, // 1
      adults: passengers.adultCount // 1
    };

    dispatch(fetchDepartingTrips({ history, formValues }));
  };

  render() {
    const { suggestions, isSafeToClickContinueButton, fetchingLocationSuggestions } = this.props;

    return (
      <div>
        <Loader isHidden={!fetchingLocationSuggestions} />
        <Page
          {...{...suggestions, isSafeToClickContinueButton}}
          handleRadioClick={this.handleRadioClick}
          handleContinueButtonClick={isSafeToClickContinueButton ? this.handleContinueButtonClick : undefined}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  // If location is manually_entered, then render what comes from API i.e. state.trips.locationSuggestions
  // If not, render location item already in redux store
  const {
    originSuggestions, 
    destinationSuggestions,
  } = state.trips.locationSuggestions; // TODO put locationSuggestions in its own reducer
  const { fetchingLocationSuggestions } = state.trips; // TODO put locationSuggestions in its own reducer
  const landingPageFormValues = getLandingPageFormValues(state); // Use values to perform fetchDepartures
  const destination = landingPageFormValues.to;
  const origin = landingPageFormValues.from;
  const isOriginManuallyEntered = origin.locationIdType === "manually_entered";
  const isDestinationManuallyEntered = destination.locationIdType === "manually_entered";
  const isSafeToClickContinueButton = !isOriginManuallyEntered && !isDestinationManuallyEntered;
  
  return {
    ...landingPageFormValues,
    isSafeToClickContinueButton, 
    fetchingLocationSuggestions,
    suggestions: {
      originSuggestions, // render API result, or info that already exists in store
      destinationSuggestions
    }
  };
}

LocationSuggestionsPage.propTypes = {
  suggestions: PropTypes.object.isRequired,
  fetchingLocationSuggestions: PropTypes.bool,
  isSafeToClickContinueButton: PropTypes.bool.isRequired
};
export default connect(mapStateToProps)(LocationSuggestionsPage);



// WEBPACK FOOTER //
// ./src/scenes/LocationSuggestionsPage/index.js